import { Capacitor } from '@capacitor/core';

/**
 * Detecção de plataforma para billing (Plano B).
 * Web → Pagar.me | Native (iOS/Android) → Store IAP / Play Billing
 */

export function getAppPlatform() {
	try {
		return Capacitor.getPlatform();
	} catch (error) {
		return 'web';
	}
}

export function isNativeApp() {
	try {
		return Capacitor.isNativePlatform();
	} catch (error) {
		return false;
	}
}

export function isIosApp() {
	return getAppPlatform() === 'ios';
}

export function isAndroidApp() {
	return getAppPlatform() === 'android';
}

export function isWebApp() {
	return !isNativeApp();
}
